import { render } from "./FacilityAreasModule.vue?vue&type=template&id=7c945c79&scoped=true"
import script from "./FacilityAreasModule.vue?vue&type=script&lang=js"
export * from "./FacilityAreasModule.vue?vue&type=script&lang=js"

import "./FacilityAreasModule.vue?vue&type=style&index=0&id=7c945c79&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c945c79"

export default script